module.exports = __webpack_public_path__ + "img/x-square.ddb8f8e8.svg";